import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'
import { Container, Row, Col } from 'react-bootstrap'
import Text from 'components/common/Text'
import GettingStarted1 from 'assets/inline/GettingStarted1.png'
import GettingStarted2 from 'assets/inline/GettingStarted2.png'
import GettingStarted3 from 'assets/inline/GettingStarted3.png'

export const GettingStartedBlock = () => {
	const { data: tenantProfile } = useTenantProfile()
	const tenantName = tenantProfile?.name
	const secondaryColor = tenantProfile?.theme?.secondaryColor

	return (
		<Container style={{ display: 'flex', flexDirection: 'column', gap: 40 }}>
			<Row>
				<Col>
					<Text
						size={34}
						style={{
							fontWeight: 'bold',
							textAlign: 'center',
						}}
					>
						Getting started is easy!
					</Text>
				</Col>
			</Row>
			<Row>
				<Col
					xs={12}
					md={4}
					style={{ display: 'flex', flexDirection: 'column', gap: 20, marginBottom: 50 }}
				>
					<img src={GettingStarted1} style={{ width: '100%' }} />
					<div>
						<Text size={12} color={secondaryColor} align='center'>
							Step 1
						</Text>
						<Text size={20} style={{ fontWeight: 'bold' }} align='center'>
							Sign Up
						</Text>
						<Text align='center'>
							Create a profile and in 1-2 minutes you'll have a personalized partner page!
						</Text>
					</div>
				</Col>
				<Col
					xs={12}
					md={4}
					style={{ display: 'flex', flexDirection: 'column', gap: 20, marginBottom: 50 }}
				>
					<img src={GettingStarted2} style={{ width: '100%' }} />
					<div>
						<Text size={12} color={secondaryColor} align='center'>
							Step 2
						</Text>
						<Text size={20} style={{ fontWeight: 'bold' }} align='center'>
							Share
						</Text>
						<Text align='center'>
							Share your partner page with clients and prospects across the web, email and social
							media.
						</Text>
					</div>
				</Col>
				<Col
					xs={12}
					md={4}
					style={{ display: 'flex', flexDirection: 'column', gap: 20, marginBottom: 50 }}
				>
					<img src={GettingStarted3} style={{ width: '100%' }} />
					<div>
						<Text size={12} color={secondaryColor} align='center'>
							Step 3
						</Text>
						<Text size={20} style={{ fontWeight: 'bold' }} align='center'>
							Grow
						</Text>
						<Text align='center'>
							Grow your trusted relationships by helping clients save money throughout their
							homeownership experience.
						</Text>
					</div>
				</Col>
			</Row>
		</Container>
	)
}
